import { Product } from '../../types/product.types';
import { getSingleProductAnalytics } from '../helper';

export const productAnalytics = (product: Product, isAddToCart: boolean = false) => {
  return {
    ...getSingleProductAnalytics(product),
    isAddToCart,
  };
};

export const marketingAnalytics = (product: Product) => {
  return {
    productId: product.id,
    sku: product.sku,
    price: product.displayPrice,
    originPrice: product.originPrice,
  };
}; 